import { Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import { ApiService } from '../../../api.service';
import * as moment from 'moment';
moment.locale('fr');

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.scss']
})
export class QuotesComponent implements OnInit {

  constructor(private api:ApiService) { }

  alerts:any;

  quotes:any;

  event:any;

  unregistered:any;

  displayQuote = false;
  quote:any;

  @Input('fromPro') fromPro = 0;

  @Output() orderCharged = new EventEmitter();

  today:any = new Date();

  ngOnInit() {

  }

  refresh(event){    
    let CustomerIds = [];

    event.fromPro = this.fromPro;
    event.ColleagueId = this.api.adminUser.value.ebp_id; 

    this.event = event;

    this.quotes = undefined;

    this.api.post("pro=getDocsByColleagueId",event).then((res:any)=>{
      if(res){
        this.quotes = res.filter(item=>{
          CustomerIds.push(item.CustomerId);
          if(item.DeliveryDate != null){
            if(parseFloat(item.TotalWeight) >= 50)
              item.cmDate = moment(item.DeliveryDate.date).subtract(5, "days");
            else
              item.cmDate = moment(item.DeliveryDate.date).subtract(2, "days");
          }
          return true;
        });
        this.alerts = {};
        this.api.post("SPDO_krolServer=select",{database:'customer_alert',where:"CustomerId IN ('"+CustomerIds.join("','")+"') AND state = 1"}).then((res:any)=>{
          if(res && res.data){
            for(let row of res.data){
              this.alerts[row.CustomerId] = this.alerts[row.CustomerId] ? [...this.alerts[row.CustomerId],row] : [row];
            }
          }
        });
      }
    });
    this.api.postWS("order=checkForQuotes",{ColleagueId:event.ColleagueId}).then((res:any)=>{
      this.unregistered = res;
    });
  }

  edit(row){
    this.api.getJson("https://ws.blackrockgames.fr/order_json/"+row.DocumentNumber+".json",).then((res:any)=>{
      res.edit = true;
      res.ref = row.Reference;
      res.DocumentNumber = row.DocumentNumber;

      // Flags d'édition posés tout de suite (ne pas dépendre uniquement de chargeOrder)
      this.api.order.edit = true;
      this.api.order.ref = row.Reference;
      this.api.order.DocumentNumber = row.DocumentNumber;
      if (res.ThirdOrderNumber !== undefined) {
        this.api.order.ThirdOrderNumber = res.ThirdOrderNumber;
      }
      if (res.DiscountRate !== undefined) {
        this.api.order.DiscountRate = res.DiscountRate;
      }
      if (res.freeShipping !== undefined) {
        this.api.order.freeShipping = res.freeShipping;
      }
      if (res.payment) {
        this.api.order.payment = Object.assign({}, res.payment);
      }
      if (res.notes !== undefined) {
        this.api.order.notes = res.notes;
      }
      if (res.xx_Code_Festival !== undefined) {
        this.api.order.xx_Code_Festival = res.xx_Code_Festival;
      }
      if (res.dotation !== undefined) {
        this.api.order.dotation = res.dotation;
      }
      if (res.DeliveryDate) {
        this.api.order.DeliveryDate = new Date(res.DeliveryDate);
      }
      if (res.deliveryAddress !== undefined) {
        this.api.order.deliveryAddress = res.deliveryAddress;
      }
      if (res.addressChanged !== undefined) {
        this.api.order.addressChanged = res.addressChanged;
      }
      if (res.createBy != null && res.createBy != 'undefined') {
        this.api.order.createBy = res.createBy;
      }

      // Modif devis : type par défaut = Commande
      this.api.order.devis = false;
      res.devis = false;
      
      let i = 1;
      for(let p of res.prods){
        if(!p.id)
          p.id = new Date().getTime() + i;

        if((parseInt(p.RealStock) < 5) && new Date(p.release_date) <= this.today && p.ItemType == '0'){
          p.rupture = true;
        }
        
        i++;     
      }

      for(let p of this.api.order.prods){
        p.quantity = 0;
        this.api.changeQty(p);
      }

      console.log(this.api.order);

      setTimeout(()=>{
        if(res.prods){
          this.api.order.prods = res.prods.filter(item => item.quantity > 0);
          this.api.order.edit = true;
          this.api.order.ref = res.ref;
          this.api.order.DocumentNumber = res.DocumentNumber;
          if(this.api.user)  
            this.api.totalOrder();
          this.orderCharged.emit(res);
        }
      },500);
    });
  }

  show(row){
    this.api.postWS("sql=select",{fields:"*",database:'SaleDocumentLine',where:"DocumentId = '"+row.Id+"'"}).then((res:any)=>{
      row.lines = res;
      this.quote = row;
      this.displayQuote = true;
    });
  }
  
  delete(row){
    this.api.confirm("Sûr ?").then(res=>{
      if(res == 'ok'){
        this.api.postWS("tools=deleteQuote",{DocumentNumber:row.DocumentNumber}).then((res:any)=>{
          this.refresh(this.event);    
        });
      }
    });
  }

  passQuote(row){
    //this.api.showCustomerAlert(row.CustomerId,'onOrder');
    this.api.postWS("sql=update",{database:'SaleDocument',data:{DocumentState:3},where:"DocumentNumber = '"+row.DocumentNumber+"'"}).then((res:any)=>{
        this.refresh(this.event);    
    });
  }
}
